import { KeyColors } from "@/theme/colors";
import styled from "styled-components";
import { buttonBaseStyles, onClickWithAnalytics } from "./common";
import { ButtonCommonProps } from "./types";

/**
 * Types
 */

type ButtonOutlineProps = ButtonCommonProps & {
  borderColor?: KeyColors;
};

/**
 * Styled Components
 */

export const StyledButtonOutline = styled.button<
  Omit<ButtonOutlineProps, "text">
>`
  ${
    // @ts-expect-error check this error with styled-components
    buttonBaseStyles
  };
  ${({ borderColor = "black", theme }) => `
    background-color: ${theme.Colors.white};
    border: 1px solid ${theme.Colors[borderColor]};
    padding: 6px;
    &:hover {
      opacity: 0.8;
    }

    :disabled {
      background-color: ${theme.Colors.white};
      border: 1px solid ${theme.Colors.gray200};
      color: ${theme.Colors.gray300};
    }
  `}
`;

/**
 * ButtonOutline Component
 */

export const ButtonOutline = ({
  disabled = false,
  onClick,
  testId,
  text,
  type = "button",
  analyticsContext,
  ...rest
}: ButtonCommonProps) => (
  <StyledButtonOutline
    data-testid={testId}
    disabled={disabled}
    onClick={() =>
      onClickWithAnalytics(onClick, {
        button_text: text,
        button_type: type,
        ...analyticsContext ?? {},
      })
    }
    type={type}
    {...rest}
  >
    {text}
  </StyledButtonOutline>
);
